export const CREATE_ENTITY = `
  mutation CreateEntity($entityName: String!, $attributes: AWSJSON!) {
    createEntity(entityName: $entityName, attributes: $attributes)
  }
`;

export const UPDATE_ENTITY = `
  mutation UpdateEntity($entityName: String!, $attributes: AWSJSON!) {
    updateEntity(entityName: $entityName, attributes: $attributes)
  }
`;

export const DELETE_ENTITY = `
  mutation DeleteEntity($entityName: String!, $id: String!) {
    deleteEntity(entityName: $entityName, id: $id)
  }
`;

export const RESET_ENTITY = `
  mutation ResetEntity($entityName: String) {
    resetEntity(entityName: $entityName)
  }
`;

export const RESET_ALL = `
  mutation ResetAll {
    resetAll
  }
`;
